module.exports = __webpack_public_path__ + "static/proven-expertise-17b519e45bbbd3f764fd265afa2b7fdf.svg";